module.exports = __webpack_public_path__ + "star-classic-granite.a8f33d3bd3aa442c32bf.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/star-classic-granite.svg
// module id = ../../../../../src/assets/img/star-classic-granite.svg
// module chunks = main